<app-splitbutton [elements]="exportReportSelectedUsersSplitButtons"></app-splitbutton>

<nz-modal [(nzVisible)]="isResetModalVisible"
		nzTitle="{{ 'workflow.resetData' | translate }}"
		(nzOnCancel)="handleResetCancel()"
		(nzOnOk)="resetData()"
		nzOkText="{{ 'actions.OK' | translate }}"
		nzCancelText="{{ 'actions.cancel' | translate }}"
>
	<ng-container *nzModalContent>
		{{ 'workflow.resetMessage.warning' | translate }}
	</ng-container>
</nz-modal>
